module.exports = __webpack_public_path__ + "img/japanese-“passing-grade”-button.19a297a3.png";